import { Tooltip, type TooltipProps } from '@ui/components/tooltips/Tooltip';

const HINT_TOOLTIP_DELAY_IN_MILLISECONDS = 400;

type HintTooltipProps = Omit<TooltipProps, 'delay'>;

const HintTooltip = (props: HintTooltipProps) => <Tooltip {...props} delay={HINT_TOOLTIP_DELAY_IN_MILLISECONDS} />;

export { HintTooltip };
export type { HintTooltipProps };
